import { render, staticRenderFns } from "./reporteHistorialAlumno.vue?vue&type=template&id=6bc3a782&scoped=true&"
import script from "./reporteHistorialAlumno.vue?vue&type=script&lang=js&"
export * from "./reporteHistorialAlumno.vue?vue&type=script&lang=js&"
import style0 from "./reporteHistorialAlumno.vue?vue&type=style&index=0&id=6bc3a782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc3a782",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VCol,VProgressCircular,VRow,VSelect,VTextField})
